// Module
var code = `<div class="d-flex align-items-center justify-content-center" style="min-height: calc(100vh - 56px)">
	<div class="col-11 col-sm-8 col-md-5 col-lg-4">
		<div class="text-center mb-4">
			<i class="fas fa-tv fa-3x mb-3" style="color: #f57c00"></i>
			<h1 class="mb-1">
				<small class="text-muted d-block" style="font-size: 0.45em; letter-spacing: 0.1em; text-transform: uppercase">Welcome to</small>
				JumboTRON
			</h1>
			<p class="text-muted mb-0">Real-time content for the big screens at Roskilde Festival</p>
		</div>
		<div class="card shadow">
			<div class="card-body p-4 text-center">
				<p class="text-muted mb-4">Sign in with your Roskilde Festival account to continue.</p>
				<div ng-if="\$ctrl.error" class="alert alert-danger py-2 mb-3" role="alert">
					<i class="fas fa-exclamation-circle me-1"></i> {{ \$ctrl.error }}
				</div>
				<div class="d-grid">
					<button
						class="btn btn-lg text-white"
						style="background-color: #f57c00; border-color: #e56c00"
						ng-disabled="\$ctrl.working"
						type="button"
						ng-click="\$ctrl.signIn()"
					>
						<span ng-if="!\$ctrl.working"><i class="fab fa-microsoft me-2"></i>Sign in with Microsoft</span>
						<span ng-if="\$ctrl.working"><i class="fas fa-circle-notch fa-spin me-2"></i>Redirecting...</span>
					</button>
				</div>
			</div>
		</div>
		<p class="text-center text-muted mt-3" style="font-size: 0.8em">&copy; Roskilde Festival</p>
	</div>
</div>
`;
// Exports
export default code;